import { element } from 'protractor';
import { Service } from './../../models/service.model';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SubheaderService } from 'src/app/core/_base/layout';
import { AppConfig } from 'src/app/core/_config/app.config';
import { LoaderService } from 'src/app/core/_config/loader.service';
import { DueDateInBatchesParams } from '../../models/due-date-in-batches-params.model';
import { DueDateInBatchesService } from '../../services/due-date-in-batches.service';
import { Period } from '../../models/period.model';
import { SimpleListConfig } from 'src/app/models/simpleListConfig';
import { SessionBusiness } from 'src/app/core/_config/sessionBusiness.service';
import { DOCUMENT } from '@angular/common';
import DueDateInBatches from '../../models/due-date-in-batches.model';
import { YesOrNoComponent } from 'src/app/dialog/yes-or-no/yes-or-no.component';
import { Observable } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'kt-due-date-in-batches',
    templateUrl: './due-date-in-batches.component.html',
    styleUrls: ['./due-date-in-batches.component.scss'],
})
export class DueDateInBatchesComponent implements OnInit {
    public resOk: boolean;
    public lines: any[] = [];
    public billetsSelected: Array<DueDateInBatches> = [];
    public filtersAltered: boolean;

    public range = new FormGroup({
        dateStart: new FormControl({ value: '', disabled: true }, [Validators.required]),
        dateFinal: new FormControl({ value: '', disabled: true }),
    });

    public newDueDateForm = new FormControl({ value: '', disabled: true });
    private dueDays: Array<number>;

    public dueDateInBatchesParams: DueDateInBatchesParams;

    public periodList: Array<Period>;
    public serviceList: Array<Service>;

    simpleTableConfig: SimpleListConfig = {
        useSortable: true,
        useFilter: false,
        usePagination: true,
        pageSize: [15, 20, 30],
        dateformat: 'dd/MM/yyyy',
        displayColumns: [
            {
                displayName: 'BILLET.contract',
                field: 'contractDescription',
            },
            {
                displayName: 'BILLET.student',
                field: 'beneficiaryName',
            },
            {
                displayName: 'BILLET.number',
                field: 'billetNumber',
            },
            {
                displayName: 'BILLET.dueDate',
                field: 'billetDueDate',
                type: 'date',
            },
            {
                displayName: 'BILLET.value',
                field: 'billetValue',
                type: 'currency',
            },
            {
                displayName: 'BILLET.registered',
                field: 'billetRegistered',
                type: 'icon-true-or-false',
            },
            {
                field: 'action',
                type: 'action',
            },
        ],
        page: {
            totalElements: 0,
            index: 0,
            size: 0,
        },
        lineActions: [
            {
                action: (a) => this.onCurrentAccount(a),
                label: 'Conta Corrente',
                color: 'primary',
                icon: 'content_paste',
            },
        ],
        selection: {
            type: 'multiple',
        },
    };

    constructor(
        private sessionBusiness: SessionBusiness,
        public _loaderService: LoaderService,
        public _spinner: NgxSpinnerService,
        public _subheaderService: SubheaderService,
        private _notificationsService: NotificationsService,
        private _cdRef: ChangeDetectorRef,
        private _dialog: MatDialog,
        private _config: AppConfig,
        private _dueDateInBatchesService: DueDateInBatchesService,
        private _translate: TranslateService,
        @Inject(DOCUMENT) readonly document: Document
    ) {
        _subheaderService.setTitle(this._translate.instant('BILLET.due_date_in_batches'));
        this.dueDateInBatchesParams = new DueDateInBatchesParams();
        this.periodList = new Array<Period>();
        this.serviceList = new Array<Service>();
        this.dueDays = new Array<number>();
        this.filtersAltered = false;
    }

    ngOnInit(): void {
        if (
            this.sessionBusiness.LegalEntityIdContext != undefined &&
            this.sessionBusiness.LegalEntityIdContext != null
        ) {
            this.getPeriodList(this.sessionBusiness.LegalEntityIdContext);
            this.getDueDaysByLegalEntity(this.sessionBusiness.LegalEntityIdContext);
        }
    }

    private get window(): Window {
        return this.document.defaultView;
    }

    public onSearch(): void {
        this.resOk = false;
        this._loaderService.show();
        this._cdRef.detectChanges();
        this._dueDateInBatchesService.getDueDateInBatches(this.dueDateInBatchesParams).subscribe((result) => {
            this._loaderService.hide();
            this.filtersAltered = false;
            if (result.success) {
                this.lines = result.data.result;
                this.simpleTableConfig.page.index = result.data.currentPage - 1;
                this.simpleTableConfig.page.totalElements = result.data.totalRecords;
                this.resOk = true;
                this._cdRef.detectChanges();
            }
        });
    }

    private getPeriodList(legalEntityId: string): void {
        this._loaderService.show();
        this._dueDateInBatchesService.getPeriodsByLegalEntity(legalEntityId).subscribe((result) => {
            this._loaderService.hide();
            if (result.success) {
                this.periodList = result.data;
            }
        });
    }

    private getDueDaysByLegalEntity(legalEntityId: string): void {
        this._loaderService.show();
        this._dueDateInBatchesService.getDueDaysByLegalEntity(legalEntityId).subscribe((result) => {
            this._loaderService.hide();
            if (result.success) {
                if (result.data?.length > 0) {
                    this.dueDays = result.data;
                }
            }
        });
    }

    public onReloadTable(ev: any): void {
        this.dueDateInBatchesParams.itemsPage = ev.pageSize;
        this.dueDateInBatchesParams.currentPage = ev.pageIndex + 1;
        this.simpleTableConfig.page.size = ev.pageSize;

        this.onSearch();
    }

    public onRangeDateApply() {
        this.filtersAltered = true;
        this.dueDateInBatchesParams.dueDateStart = this.range.value.dateStart?.toJSON();
        this.dueDateInBatchesParams.dueDateFinal = this.range.value.dateFinal?.toJSON();
    }

    public onPeriodChange(period: Period) {
        this.filtersAltered = true;
    }

    public onServiceChange(service: Service) {
        this.filtersAltered = true;
    }

    public onCleanFilter(): void {
        this.dueDateInBatchesParams = new DueDateInBatchesParams();

        this.range.patchValue({ dateStart: '', dateFinal: '' });

        this.filtersAltered = true;
    }

    public onResSelectLine(event: any): void {
        this.billetsSelected = event;
    }

    private onCurrentAccount(element: DueDateInBatches): void {
        this.redirect(`${this._config.urlOldAfs}AccountsReceiving/AccountsReceiving/?contractId=${element.contractId}`);
    }

    private redirect(url: string, target = '_blank'): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            try {
                resolve(!!this.window.open(url, target));
            } catch (e) {
                reject(e);
            }
        });
    }

    private yesOrNoDialog(title: string, text: string): Observable<any> {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.minWidth = 260;
        dialogConfig.data = {
            title: title,
            text: text,
        };
        const dialogRef = this._dialog.open(YesOrNoComponent, dialogConfig);

        return dialogRef.afterClosed();
    }

    public onAlterDueDate(all: boolean = false): void {
        if (this.lines.length > 0) {
            this.yesOrNoDialog(
                this._translate.instant('BILLET.confirmation_of_alteration'),
                this._translate.instant('BILLET.are_you_sure_you_want_to_change_expiration_date') +
                    ' ' +
                    (all
                        ? this._translate.instant('BILLET.of_all_filtered_bills')
                        : this._translate.instant('BILLET.of_the_selected_bills')) +
                    '?'
            ).subscribe((result) => {
                if (result) {
                    this.yesOrNoDialog(
                        this._translate.instant('BILLET.discount'),
                        this._translate.instant('BILLET.discounts_will_accompany_change') + '?'
                    ).subscribe((accompaniesDiscount) => {
                        this.alterDueDate(accompaniesDiscount, all);
                    });
                }
            });
        }
    }

    private alterDueDate(accompaniesDiscount: boolean, all: boolean = false): void {
        this._spinner.show();
        this._notificationsService.info(this._translate.instant('BILLET.wait_for_processing') + '!');
        this._dueDateInBatchesService
            .postAlterDueDateInBatch(
                this.dueDateInBatchesParams.periodId,
                this.dueDateInBatchesParams.dueDateStart,
                this.billetsSelected,
                this.newDueDateForm.value.toJSON(),
                all,
                accompaniesDiscount,
                this.sessionBusiness.LegalEntityIdContext,
                this.dueDateInBatchesParams.dueDateFinal,
                this.dueDateInBatchesParams.serviceId
            )
            .subscribe((result) => {
                this._spinner.hide();
                if (result.success) {
                    this._notificationsService.success(
                        this._translate.instant('BILLET.expiration_date_successfully_changed') + '!'
                    );
                    this.newDueDateForm.setValue('');
                    this.dueDateInBatchesParams.currentPage = 1;
                    this.onSearch();
                }
            });
    }

    public filterNewDueDate = (d: Date | null): boolean => {
        const date = d || new Date();
        const dateNow = new Date();

        date.setHours(0, 0, 0, 0);
        dateNow.setHours(0, 0, 0, 0);

        if (date.getTime() + 86400000 < new Date().getTime()) {
            return false;
        }

        if (this.dueDays.length > 0) {
            return this.dueDays.includes(date.getDate());
        }
        return true;
    };
}
